import React, { useState } from 'react';
import {
  Card,
  Typography,
  Button,
  ButtonGroup,
  Icon
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Scrollbar from 'react-perfect-scrollbar';
import CTAPreviewImages from './CTAPreviewImages';


const useStyles = makeStyles(() => ({
  gallery: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(2, 1fr)',
    gridGap: '36px',
    maxWidth: '1200px',
    minHeight: '580px',
    width: '100%',
    margin: '0 auto 20px',
  },
  gallery_mobile: {
    display: 'flex',
    flexDirection: 'column',
    width: '375px',
    height: '600px',
    margin: '0 auto',
    border: '15px groove #222',
    borderRadius: '25px',
    position: 'relative',
    overflow: 'hidden'
  }
}));

const CTAPreview: React.FC<CTAPreviewProps> = ({ values }) => {
  const classes = useStyles();
  const [mobileView, setMobileView] = useState<boolean>(false);

  return (
    <Card className="mt-5 p-8 min-h-600">
      <div className="flex items-center justify-between mb-5">
        <Typography variant="h4">Preview</Typography>
        <ButtonGroup disableElevation variant="outlined">
          <Button
            color="primary"
            variant={mobileView ? 'outlined' : 'contained'}
            title="Desktop View"
            onClick={() => setMobileView(false)}
          >
            <Icon>desktop_windows_icon</Icon>
          </Button>
          <Button
            color="primary"
            variant={mobileView ? 'contained' : 'outlined'}
            title="Mobile View"
            onClick={() => setMobileView(true)}
          >
            <Icon>phone_android</Icon>
          </Button>
        </ButtonGroup>
      </div>
      <div className={mobileView ? classes.gallery_mobile : classes.gallery}>
        {mobileView ? (
          <Scrollbar options={{ suppressScrollX: true }}>
            <CTAPreviewImages values={values} mobileView={mobileView} />
          </Scrollbar>
        ) : (
          <CTAPreviewImages values={values} mobileView={mobileView} />
        )}
      </div>
    </Card>
  );
};

export default CTAPreview;
